import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=5fcd0c0a"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-life-proof-portal/hive-life-proof-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fcd0c0a')) {
      api.createRecord('5fcd0c0a', component.options)
    } else {
      api.reload('5fcd0c0a', component.options)
    }
    module.hot.accept("./BasePagination.vue?vue&type=template&id=5fcd0c0a", function () {
      api.rerender('5fcd0c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BasePagination.vue"
export default component.exports